import { Link } from 'react-router-dom';
import { siteIntro } from '@/mocks/site';

export default function IntroBand() {
  return (
    <section className="mx-auto mt-10 max-w-[1440px] px-4 md:mt-14 md:px-6">
      <div className="overflow-hidden rounded-xl bg-primary-950">
        <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:gap-10 md:p-12">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-800 px-3 py-1 text-xs font-medium text-primary-100">
              <i className="ri-award-line text-accent-400"></i>
              权威综合门户
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              {siteIntro.title}
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-primary-100">{siteIntro.desc}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/contact"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-700 px-5 py-2.5 text-sm font-medium text-primary-100 transition-colors hover:bg-primary-900"
              >
                <i className="ri-customer-service-2-line"></i>
                联系合作
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 self-center">
            {siteIntro.stats.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-primary-900/70 p-4 md:p-5">
                <div className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{stat.value}</div>
                <div className="mt-1 text-xs text-primary-200 md:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}